import { Box, IconButton, Stack, styled, Typography } from "@mui/material"
import { Facebook } from "@mui/icons-material"
import { Link } from "react-router-dom"
const SocialBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: 10,
})
const TextStyled = styled(Typography)({
  color: "white",
  textDecoration: "none",
  "&:hover": {
    color: "red",
  },
})

const Footer = () => {
  return (
    <Box
      sx={{
        background: "black",
        height: { xs: "200px", sm: "200px", md: "150px" },
        marginTop: 5,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "column", md: "row" }}
        p={3}
        justifyContent="space-around"
        alignItems="center"
      >
        <Box>
          <Link to="/contacts" style={{ textDecoration: "none" }}>
            <Typography
              color="white"
              align="center"
              sx={{
                "&:hover": {
                  color: "#d32f2f",
                },
              }}
            >
              Contact Us
            </Typography>
          </Link>
        </Box>

        <Box>
          <Typography color="white" align="center">
            Categories
          </Typography>
          <Stack>
            <TextStyled
              align="center"
              variant="body2"
              component={Link}
              to="/posts"
            >
              Posts
            </TextStyled>
            <TextStyled
              align="center"
              variant="body2"
              component={Link}
              to="/quiz"
            >
              Quiz
            </TextStyled>
            <TextStyled
              align="center"
              variant="body2"
              component={Link}
              to="/jobs"
              sx={{ textDecoration: "none" }}
            >
              Jobs
            </TextStyled>
          </Stack>
        </Box>
        <Box>
          <Typography color="white" align="center">
            Follow Us
          </Typography>
          <SocialBox>
            <a
              target="_blank"
              href="https://www.facebook.com/"
              rel="noreferrer noopener"
            >
              <IconButton sx={{ color: "white" }}>
                <Facebook />
              </IconButton>
            </a>
          </SocialBox>
        </Box>
      </Stack>
    </Box>
  )
}
export default Footer
